// extracted by mini-css-extract-plugin
export default {"rightnav":"index_rightnav_sSVR2","item":"index_item_KkRPY","dian":"index_dian_EH9Ex"};